// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GemCustomExtended } from '../../../assets/icons/extended/entities/gem-custom.svg?react';
import { createIcons } from '../../Icon';
const GemCustomIcon = /* @__PURE__ */ createIcons('GemCustom', {
    extended: GemCustomExtended
});
GemCustomIcon.supportedTypes = ['extended'];
GemCustomIcon.category = 'entities';
export default GemCustomIcon;
